export default __webpack_public_path__ + "ae67c2b.png";